import uniq from 'lodash/uniq';

/** Coverage types an imported producer may be given, or null when the relying party has no producer flow. */
export function getProducerCoverageTypes(
    producerFlowEnabled: boolean | undefined, requirementTypes: string[],
): string[] | null {
    return producerFlowEnabled ? uniq(requirementTypes) : null;
}
